import Loader from "@/javascript/components/loader"
import { createLogger, nodeToString } from "@/javascript/utils/logging"

class MaxWords {
  constructor (elem, opts = {}) {
    this.logger = createLogger('MaxWords')
    this.elem = elem
    this.maxWords = opts.maxWords || this.elem.dataset.maxWords
    this.wordsLeftText = opts.wordsLeftText || this.elem.dataset.maxWordsLeftText || 'words left'
    this.errorMessage = opts.errorMessage || this.elem.dataset.maxWordsErrorMessage || 'too many words'
    this.logger.debug(`Initialized MaxWords for ${nodeToString(elem)} with limit: ${this.maxWords}`)
    this._bind()
  }

  _buildCounter() {
    new Promise((resolve) => {
      this.counter = this.elem.querySelector('.errors') || document.createElement('div')
      this.counter.classList.add('max-words')
      this.elem.appendChild(this.counter)
      resolve(this.counter)
    })
  }

  _bind() {
    this._buildCounter()
    const inputElem = this.elem.querySelector('input[type="text"], textarea')
    if(!inputElem) {
      return
    }

    inputElem.addEventListener('keyup', (e) => {
      const currentWordCount = inputElem.value.trim().split(' ').filter((string)=>string.length).length
      const wordsLeftCount = this.maxWords - currentWordCount
      this.counter.innerHTML = wordsLeftCount + ' ' + this.wordsLeftText

      if(wordsLeftCount < 0) {
        this.logger.debug(`Word limit exceeded in ${nodeToString(this.elem)}: ${currentWordCount}/${this.maxWords}`)
        this.counter.classList.add('errors')
        this.counter.innerHTML = this.errorMessage
      } else {
        this.counter.classList.remove('errors')
      }

      if(wordsLeftCount == this.maxWords) {
        this.counter.innerHTML = null
      }
    })
  }
}

// Create a logger for the loader function
const loaderLogger = createLogger('MaxWordsLoader')

Loader.functional((content, resolve) => {
  const maxWordElems = content.querySelectorAll('[data-max-words]')
  loaderLogger.debug(`Found ${maxWordElems.length} elements with max-words in ${nodeToString(content)}`)
  
  maxWordElems.forEach((elem) => {
    if(elem.maxWordsEnabled) {
      return
    }
    elem.maxWordsEnabled = true
    elem.maxWords = new MaxWords(elem)
  })

  resolve()
})
